import type { FaireProductEntity } from "../../entity_types/product";

export const potluck_doenjang_1: FaireProductEntity = {
  token: "potluck-doenjang-1",
  type: "product",
  name: "Doenjang Fermented Soybean Paste",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/75acd4ea788037ed83556862a2ba7e6d54c50c250950790b35ccc44f1f8271fc.webp",
  priceDollars: 14,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  weight: 1.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 3,
  },
  description:
    "Deeply savory fermented soybean paste for stews, marinades, and dipping.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["korean", "fermented", "condiment", "artisanal"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
